import React from 'react';

export default function EducationCard3(props) {
	// console.log('EducationCard', props);
	return (
		<section className="EducationCard md:mx-4 min-w-80 my-4 p-7 rounded-md shadow-lg border">
			<h2 className="text-sm md:text-lg text-blue-500 hover:underline">
				<img
					src="https://matt-hoelzel.s3.us-west-1.amazonaws.com/metro_state_logo.png"
					className="float-left mr-4"
					alt="metropolitan-state-university-logo"
				/>
				<strong>
					<a
						href="https://www.msudenver.edu/programs/sport-management-major-ba/"
						target="_blank"
					>
						Metropolitan State University of Denver
					</a>
				</strong>
			</h2>
			<h3 className="text-md lg:text-lg">BA, Sports Management </h3>
			<ul className="list-disc ml-4 md:ml-6 mt-2 mb-5 font-thin text-md lg:text-base clear-left pt-3">
				<li>Minors in Management and Biology</li>
				<li>20+ credits upper-division accounting and economics coursework</li>
			</ul>
		</section>
	);
}
